import { useCallback } from "react";
import { getUdvList } from "../../api/WorkOrders";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetCustomValues() {
  const setCustomValues = useWorkOrderStore((state) => state.setWoUdvList);

  const getCustomValues = useCallback(
    async (woNumber: string) => {
      const response = await getUdvList({ woNumber });
      if (!response.isError) {
        setCustomValues(woNumber, response.data);
      }
      return response;
    },
    [setCustomValues]
  );

  return { getCustomValues };
}
